import { render, staticRenderFns } from "./categoryForm.vue?vue&type=template&id=0d4e5262&scoped=true&"
import script from "./categoryForm.vue?vue&type=script&lang=js&"
export * from "./categoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4e5262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d4e5262')) {
      api.createRecord('0d4e5262', component.options)
    } else {
      api.reload('0d4e5262', component.options)
    }
    module.hot.accept("./categoryForm.vue?vue&type=template&id=0d4e5262&scoped=true&", function () {
      api.rerender('0d4e5262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledgeBaseMgr/knowledgeMgr/components/categoryForm.vue"
export default component.exports